// extracted by mini-css-extract-plugin
export default {"Input":"index_Input_c6qmA","error":"index_error_9gAuS"};